<script setup>
import { computed } from "vue";
import { usePage, Link } from "@inertiajs/vue3";

const user = computed(() => usePage().props.authUser);

const appBaseUrl = usePage().props.appBaseUrl;
</script>

<template>
    <nav class="sb-topnav navbar navbar-expand bg-white shadow-sm">
        <!-- Navbar Brand-->
        <a class="navbar-brand ps-3 d-flex align-items-center" href="#">
            <img
                :src="appBaseUrl + '/assets/images/meteraiku-logo.jpg'"
                class="brand-image"
                alt="Meteraiku Logo"
            />
            <div class="brand-label">
                METERAIKU<br />
                EVENT
            </div>
        </a>
        <!-- Sidebar Toggle-->
        <button
            class="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0"
            id="sidebarToggle"
            href="#!"
        >
            <span class="material-icons" style="transform: scaleX(-1)"
                >segment</span
            >
        </button>
        <!-- Navbar Search-->
        <form
            class="d-none d-md-inline-block form-inline ms-auto me-0 me-md-3 my-2 my-md-0"
        ></form>
        <!-- Navbar-->
        <ul class="navbar-nav ms-auto ms-md-0 me-lg-4 align-items-center">
            <li class="nav-item dropdown">
                <a
                    class="nav-link d-flex align-items-center justify-content-center"
                    id="navbarDropdown"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    <span v-if="user.picture" class="profile-picture">
                        <img
                            :src="user.picture"
                            class="preview-picture"
                            alt="profile picture"
                        />
                    </span>
                    <i v-else class="fas fa-user fa-fw"></i>
                    <span class="ms-2 d-none d-lg-block">{{ user.name }}</span>
                </a>
                <ul
                    class="dropdown-menu dropdown-menu-end"
                    aria-labelledby="navbarDropdown"
                >
                    <li>
                        <Link class="dropdown-item" href="/admin/profile">
                            Profile
                        </Link>
                    </li>
                    <li>
                        <hr class="dropdown-divider" />
                    </li>
                    <li>
                        <Link
                            class="dropdown-item"
                            href="/logout"
                            method="post"
                            as="button"
                        >
                            Logout
                        </Link>
                    </li>
                </ul>
            </li>
        </ul>
    </nav>
</template>

<style scoped>
.new-notif {
    left: 70%;
    top: 5px;
    width: 25px;
    height: 25px;
    font-size: 9px;
}
</style>
